// Local Url
const apiURL = process.env.REACT_APP_API_URL || "http://localhost:8080/api";
const uploadsURL = process.env.REACT_APP_UPLOADS_URL || "http://localhost:8080/";
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:8080/";

export {
    apiURL,
    uploadsURL,
    SOCKET_URL
}